var _JsonConfiguration_root;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import JsonConfigurationSection from './JsonConfigurationSection';
export default class JsonConfiguration {
    constructor(source) {
        _JsonConfiguration_root.set(this, void 0);
        __classPrivateFieldSet(this, _JsonConfiguration_root, new JsonConfigurationSection(source), "f");
    }
    get root() {
        return __classPrivateFieldGet(this, _JsonConfiguration_root, "f");
    }
    getSection(key) {
        return this.root.getSection(key);
    }
    get(key) {
        return this.root.get(key);
    }
}
_JsonConfiguration_root = new WeakMap();
